<script setup>
import { defineProps, computed } from 'vue'
import ClosedCardComponent from '@/components/cards/ClosedCardComponent.vue'
import FoldedCardComponent from '@/components/cards/FoldedCardComponent.vue'
import EmptyCardComponent from '@/components/cards/EmptyCardComponent.vue'
import RevealedCardComponent from '@/components/cards/RevealedCardComponent.vue'
import { useRoomStore } from '@/stores/room'

const roomStore = useRoomStore()

const props = defineProps({
  userId: {
    type: String,
    required: true
  }
})

const user = computed(() => roomStore.users[props.userId])
const vote = computed(() => roomStore.votes.get(props.userId))


</script>
<template>
  <div class="flex flex-col w-fit h-fit items-center">
    <FoldedCardComponent v-if="user.isSpectating"/>
    <RevealedCardComponent v-else-if="vote !== undefined && roomStore.isRevealed">{{ roomStore.cards[vote] }}</RevealedCardComponent>
    <ClosedCardComponent  v-else-if="vote !== undefined && !roomStore.isRevealed" />
    <EmptyCardComponent  v-else-if="vote === undefined && !roomStore.isRevealed" />
    <div class="flex justify-center items-center font-bold mt-2 text-accent dark:text-neutral">{{ user.name }}</div>
  </div>
</template>
